import React from "react";
import { __ } from "@wordpress/i18n";
import { ReviewItem } from "./review-item";
import { GoogleIcon, ReviewsIcon, TrustPilotIcon } from "../../icons";

const REVIEW_ITEMS = [
  {
    link: "https://www.trustpilot.com/review/wpmudev.com",
    logo: TrustPilotIcon,
    ratings: __("4.8/5", "plugin-cross-sell-textdomain"),
    reviews: __("3,026+", "plugin-cross-sell-textdomain"),
  },
  {
    link: "https://www.reviews.io/company-reviews/store/wpmudev-com/",
    logo: ReviewsIcon,
    ratings: __("4.9/5", "plugin-cross-sell-textdomain"),
    reviews: __("1,751", "plugin-cross-sell-textdomain"),
  },
  {
    link: "https://www.google.com/search?q=WPMU+DEV&stick=H4sIAAAAAAAA_-NgU1I1qLAwMzFJTkq0SLY0NDdNMjW0MqgwNk4ySbZMSjQxTjEwNbAwXsTKER7gG6rg4hoGAFY8Y0Y0AAAA&hl=en&mat=CdvqvSC1kKDMElYBNqvzOh6WSjS1JTPgbDKr_wHsjlg-PedU9JwdPCfoAnD-gp_c4yhRTs4ampJofZFKWPiClgM5THRDw4IjNwi1icSMk7AHlnFbFP31PhpLbvH6V0UYHg&authuser=0#lrd=0x8644cba8c9175b51:0x33b4c9ba43d05083,1,,,",
    logo: GoogleIcon,
    ratings: __("4.8/5", "plugin-cross-sell-textdomain"),
    reviews: __("700+", "plugin-cross-sell-textdomain"),
  },
];

const Reviews = () => {
  return (
   <div className="sui-box">
    { REVIEW_ITEMS && (
          <div className="cross-sell-footer__reviews">
            {REVIEW_ITEMS.map((item, index) => (
              <ReviewItem key={index} {...item} />
            ))}
          </div>
        ) }
    </div>
  );
};

export { Reviews };
